import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import { useParams } from "@tanstack/react-router";
import type * as fhirTypes from "fhir/r4";

export interface RecommendationsResponse {
  recommendationTasks: fhirTypes.Task[];
  amazonReferOutDetails: AmazonReferOutDetails;
}

export interface AmazonReferOutDetails {
  referralReasonCode: string;
  referralUrgencyCode: string;
  referralProviderCode: string;
}

export const useRecommendations = ({
  encounterId,
  carePlanId,
  enabled,
}: { encounterId: string; carePlanId: string; enabled: boolean }) => {
  const { patientId } = useParams({ from: "/patient/$patientId" });
  return useApi<RecommendationsResponse>({
    queryOptions: {
      enabled,
      queryFn: async () => {
        const response = await axiosInstance.get<RecommendationsResponse>(
          `/charting/careplan/${carePlanId}/recommendation`,
        );

        return response.data;
      },
      queryKey:
        QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.Recommendation.DEFAULT({
          patientId,
          encounterId,
          carePlanId,
        }),
    },
  });
};
